module.exports = __webpack_public_path__ + "app/bento-components/blog-entry/media/icon.png?c25dfdfee2bcf810daf02e0a21440782";